/* dcent-app-orbit.js — 앱 페이지 §6 멀티 지갑 궤도 라벨 필 애니메이션.
 * 디자인 SoT: 20260828 드롭 src/components/AppMultiWallet.tsx RingPills (2026-08-19 확정 로직 그대로).
 *
 * - 필 위치는 rAF 에서 삼각함수로 직접 계산(x=r·sin, y=-r·cos) → 필은 항상 수평 정립. transform 만 사용.
 * - 폰 뒤 숨는 구간은 픽셀이 아니라 **각도**로 판정(|sin a| < HIDE_SIN): 두 링이 완전히 같은 속도
 *   프로파일을 타야 상대 배치가 고정돼 필끼리 안 겹친다(픽셀 기준이면 링마다 숨는 각도 폭이 달라
 *   시간이 지나며 미끄러져 겹침 — 원본 2026-08-19 실측).
 * - 숨는 구간은 FAST 배속으로 빨리 지나간다. 1.7배 제한 — 4배까지 올리면 구간 경계에서 앞뒤 필
 *   간격이 45°/4≈11° 로 압축돼 겹친다(원본 실측).
 * - prefers-reduced-motion 은 첫 프레임 배치만 하고 공전하지 않는다.
 * - IntersectionObserver 로 화면 밖에서는 rAF 를 멈춘다. dt 는 0.1s 로 클램프(탭 전환 큰 점프 방지).
 *
 * 마크업 계약(sections/dcent-page-app-multiwallet.liquid):
 *   [data-app-orbit] 루트 > [data-orbit-pill data-size data-dur data-dir data-angle] 필 N개.
 *   초기 각도의 정지 좌표는 리퀴드가 인라인 transform 으로 미리 깔아 둔다(JS 실패/로드 전 대비)
 *   — 여기서는 같은 좌표를 다시 그리며 이어받는다.
 */
const HIDE_SIN = 0.6;
const FAST = 1.7;
const RING_K = 1; /* 1 = 정원 (타원 0.62는 "찌부돼 보임" 피드백으로 되돌림 — 원본 2026-08-19) */

for (const root of document.querySelectorAll('[data-app-orbit]')) {
  const pills = Array.from(root.querySelectorAll('[data-orbit-pill]'));
  if (pills.length === 0) continue;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const angles = pills.map((pill) => Number(pill.dataset.angle) || 0);
  let raf = 0;
  let visible = true;
  let last = 0;
  const draw = (t) => {
    const dt = last ? Math.min((t - last) / 1000, 0.1) : 0;
    last = t;
    pills.forEach((pill, idx) => {
      const r = Number(pill.dataset.size) / 2;
      let a = angles[idx];
      const rad = (a * Math.PI) / 180;
      const x = r * Math.sin(rad);
      const y = -r * RING_K * Math.cos(rad);
      const hidden = Math.abs(Math.sin(rad)) < HIDE_SIN;
      if (!still) {
        a += Number(pill.dataset.dir) * (360 / Number(pill.dataset.dur)) * dt * (hidden ? FAST : 1);
        angles[idx] = a;
      }
      pill.style.transform = `translate(calc(${x.toFixed(2)}px - 50%), calc(${y.toFixed(2)}px - 50%))`;
    });
    if (!still && visible) raf = requestAnimationFrame(draw);
  };
  const io = new IntersectionObserver(([e]) => {
    visible = e.isIntersecting;
    cancelAnimationFrame(raf);
    last = 0;
    if (visible) raf = requestAnimationFrame(draw);
  });
  io.observe(root);
  raf = requestAnimationFrame(draw);
}
